export default "__VITE_ASSET__BYx7EgE2__"